module.exports = __webpack_public_path__ + "img/menu_right.d66fe203.svg";